<div class="skeleton" [ngStyle]="{
    width: width,
    height: height,
    borderRadius: borderRadius,
    marginBottom: marginBottom
  }"></div>